exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".addLibraryURLPick .assignable{position:relative;margin-bottom:30px}.addLibraryURLPick .assignable .bookDisplay{display:inline-block;width:70%}.addLibraryURLPick .assignable .actions{vertical-align:top;display:inline-block;margin-left:5%;width:25%}.addLibraryURLPick .filters{margin-bottom:10px}.addLibraryURLPick .filters .dropdown-toggle,.addLibraryURLPick .filters .scrollable-menu{text-transform:capitalize}.addLibraryURLPick .noteText{margin-bottom:15px}.addLibraryURLPick .noResultsText{margin-left:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/reading/picks/add_library_url_pick.scss
// module id = 1394
// module chunks = 0